import _PostSalesInvoiceService from "../services/post-sales-invoice-service";
import { IPostSalesInvoiceService } from "../types/services/post-sales-invoice-service";

const instance = new _PostSalesInvoiceService();

const PostSalesInvoiceService: IPostSalesInvoiceService = instance;

export default PostSalesInvoiceService;
